import Vue from 'vue'
import Cookies from 'js-cookie'
export default {
  setRole(state, val) {
    state.role = val.role;
    state.permissionLevel = val.level;
  },

  hideFooter(state, val) {
    state.hideFooter = val;
  },
  setFooterCurrentTab(state,val){
    state.currentTab = val.currentTab;
  },
  updateCurrentUser(state, val) {
    state.currentUser = val;
  },
  setCurrentTxn(state, val) {
    state.currentTxn = val;
  },

  updateCurrentAddress(state, val) {
    state.currentAddress = val;
  },

  updateAddressList(state, val) {
    state.addressList = val;
  },

  clearShoppingCart(state, val) {
    state.cartProducts = [];
    state.cartPackages = [];
  },
  setShoppingCart(state, val) {
    state.cartProducts = val.cartProducts;
  },
  setCartPackages(state, val) {
    state.cartPackages = val;
  },
  addCartProduct(state, val) {
    state.cartProducts = val;
  },
  removeCartProduct(state, val) {
    for (var i = state.cartProducts.length - 1; i >= 0; i--) {
      if (state.cartProducts[i].productID == val.productID && state.cartProducts[i].attributeID == val.attributeID) {
        state.cartProducts.splice(i, 1);
        return
      }
      else if (state.cartProducts[i].productID == val){
        state.cartProducts.splice(i, 1);
        return
      }
    }
  },
  updateCartProductQuantity(state, val) {
    for(let i=0; i<state.cartProducts.length; i++){
      if(state.cartProducts[i].ID == val.ID && state.cartProducts[i].attributeID == val.selectedProduct){
        state.cartProducts[i].quantity = val.quantity
      }else if (val.quantity == 0 ) {
        state.cartProducts.splice(val.index, 1);
      }else if(!state.cartProducts[val.index].attributeID){
        state.cartProducts[val.index].quantity = val.quantity;
      }
    }

  },
  updateCartPackagesQuantity(state, val) {
    state.cartPackages[val.index].quantity = val.quantity;
    // if (val.quantity == 0) {
    //   state.cartProducts.splice(val.index, 1);
    // }

  },
  updateCartProductKPID(state, val) {
    state.cartProducts[val.index].ID = val.ID;
  },
  updateCartPackagesKPID(state, val) {
    state.cartPackages[val.index].ID = val.ID;
  },
  updateLocalStorageCartList(state) {
    let cartListString = JSON.stringify(state.cartProducts);
    Vue.localStorage.set('cartProducts', cartListString);
    let cartToken = Cookies.get('token');
    Vue.localStorage.set('cartToken', cartToken);
    // let cartProducts = JSON.parse(Vue.localStorage.get('cartProducts'))
    // console.log( cartProducts);
  },
  updateRouteStatus(state, val) {
    state.routeStatus.path = val.path;
    state.routeStatus.query = val.query;
    let dest = val.path + "";
    dest = dest.split('/');
    let moduleString = dest[1].charAt(0).toUpperCase() + dest[1].slice(1);
    state.routeStatus.module = moduleString;
  },

  updateExchangeRate(state, val) {
    state.exchangeRate = val;
  },

  setSearchString(state, val) {
    state.searchParam.search = val.search;
  },
  setSearchCategory(state, val) {
    state.searchParam.categoryID = val.categoryID;
  },
  resetSearchParam(state, val) {
    // state.searchParam = {
    //   search:'',
    //   categoryID:'0'
    // },
    state.searchParam.search = '';
    state.searchParam.categoryID = '0';

  },
  isWechatEnv(){
    var ua = navigator.userAgent.toLowerCase();
    if(ua.match(/MicroMessenger/i)=="micromessenger") {
        return true;
     }else if(typeof WeixinJSBridge !== "undefined"){
         return true;
     }else {
         return false;
    }    
  },
  updateShippingMethod(state, val){
    state.shippingMethod = val;
  },
  updateRefreshStatus(state, val){
    state.shouldRefresh = val;
  },
  updateCurrentPages(state, val){
    state.currentPages += val
  },
  resetCurrentPages(state, val){
    state.currentPages = 10
  },
  forceRefresh(state, val){
    state.refresh  = val
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js